import { forwardRef, ButtonHTMLAttributes } from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  children: React.ReactNode;
}

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    'bg-brand-primary text-white hover:bg-brand-primary/90 focus-visible:ring-2 focus-visible:ring-brand-primary/20 focus-visible:ring-offset-1 disabled:opacity-50',
  secondary:
    'bg-neutral-border/50 text-neutral-primary hover:bg-neutral-border focus-visible:ring-2 focus-visible:ring-brand-primary/20 focus-visible:ring-offset-1 disabled:opacity-50',
  danger:
    'bg-red-600 text-white hover:bg-red-700 focus-visible:ring-2 focus-visible:ring-red-500/20 focus-visible:ring-offset-1 disabled:opacity-50',
  ghost:
    'bg-transparent text-neutral-primary hover:bg-neutral-border/50 focus-visible:ring-2 focus-visible:ring-brand-primary/20 focus-visible:ring-offset-1 disabled:opacity-50',
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', className = '', disabled, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        disabled={disabled}
        className={`inline-flex h-11 items-center justify-center rounded-xl px-4 py-2 text-sm font-medium transition-colors focus:outline-none ${variantClasses[variant]} ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';

export default Button;
